<template>
    <span class="help-block text text-danger" v-bind:class="{'d-block':isError,'d-none':!isError}">{{errorMessage}}</span>
</template>
<script>
export default {    
        props:{
            isError:false,
            errorMessage:'',
        },
        data() {
            return {}
        },
        mounted() {
        },
        created(){
        },
        methods:{          
        },        
    
}
</script>